import { addressSelector } from './addressSelector';

import type { IState } from '../../../store';

export function regionIdSelector(state: IState): number | undefined {
  const address = addressSelector(state);

  return address[0]?.id;
}
